// HILDR — ren geometri (ingen avhengigheter). Avstand, peiling og
// himmelretning brukes til å regne forflytning og skrive doktrine-tekst.
const R_KM = 6371.0088;
const rad = (d) => (d * Math.PI) / 180;
const deg = (r) => (r * 180) / Math.PI;
/** Storsirkel-avstand i kilometer (haversine). */
export function haversineKm(a, b) {
    const dLat = rad(b.lat - a.lat);
    const dLon = rad(b.lon - a.lon);
    const s = Math.sin(dLat / 2) ** 2 +
        Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) ** 2;
    return 2 * R_KM * Math.asin(Math.min(1, Math.sqrt(s)));
}
/** Initiell peiling a→b i grader (0–360, 0 = nord). */
export function bearingDeg(a, b) {
    const y = Math.sin(rad(b.lon - a.lon)) * Math.cos(rad(b.lat));
    const x = Math.cos(rad(a.lat)) * Math.sin(rad(b.lat)) -
        Math.sin(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.cos(rad(b.lon - a.lon));
    return (deg(Math.atan2(y, x)) + 360) % 360;
}
const SECTORS8 = ['NORD', 'NORDØST', 'ØST', 'SØRØST', 'SØR', 'SØRVEST', 'VEST', 'NORDVEST'];
/** Himmelretning (8-sektor) i STORE bokstaver — doktrine-tekst. */
export function compassSector(bearing) {
    const i = Math.round((((bearing % 360) + 360) % 360) / 45) % 8;
    return SECTORS8[i];
}
//# sourceMappingURL=geo.js.map